<template>
  <div class="elite-tabs-wrapper-content">
    <div class="global-header">
      <h3>{{ inspectionForm.name }}</h3>
    </div>
    <div class="global-body">
      <dl class="width_1-2">
        <dt>
          {{ $t("COMMON.TAGS") }}
        </dt>
        <dd>
          <tags
            :tags="inspectionForm.tags"
            @tagsUpdated="inspectionFormUpdated"
          />
        </dd>
      </dl>

      <dl class="width_1-2">
        <dt>{{ $t("COMMON.NAME") }}</dt>
        <dd>
          {{ inspectionForm.name }}
        </dd>
      </dl>

      <dl class="width_1-2">
        <dt>{{ $t("FUEL_TYPES.FUEL_TYPES") }}</dt>
        <dd>
          <fuel-types :fuel-types="inspectionForm.fuel_types" />
        </dd>
      </dl>

      <dl class="width_1-2">
        <dt>{{ $t("INSPECTION_FORMS.DRIVETRAINS") }}</dt>
        <dd>
          <drivetrains :drivetrains="inspectionForm.drivetrains" />
        </dd>
      </dl>

      <dl class="width_1-2">
        <dt>{{ $t("COMMON.EXCERPT") }}</dt>
        <dd v-html="inspectionForm.excerpt"></dd>
      </dl>

      <dl class="width_1-2">
        <dt>{{ $t("INSPECTION_FORMS.MAX_POINTS") }}</dt>
        <dd>
          {{ inspectionForm.maxPoints }}
        </dd>
      </dl>

      <dl class="width_1-2">
        <dt>{{ $t("INSPECTION_FORMS.SECTIONS_COUNT") }}</dt>
        <dd>
          {{ inspectionForm.inspectionFormSections.length }}
        </dd>
      </dl>

      <dl class="width_1-2">
        <dt>{{ $t("INSPECTION_FORMS.FIELDS_COUNT") }}</dt>
        <dd>
          {{ inspectionForm.fieldsCount }}
        </dd>
      </dl>

      <dl class="width_1-2">
        <dt>{{ $t("COMMON.LOCATIONS") }}</dt>
        <dd>
          <locations :locations="inspectionForm.allowedLocations" />
        </dd>
      </dl>

      <dl
        class="width_1-2"
        v-if="$currentUserCan($permissions.PERM_VIEW_ANY_ORGANIZATIONS)"
      >
        <dt>{{ $t("COMMON.ORGANIZATION") }}</dt>
        <dd>
          <organization :organization="inspectionForm.organization" />
        </dd>
      </dl>

      <dl class="width_1-2">
        <dt>{{ $t("COMMON.CREATED_AT") }}</dt>
        <dd v-if="inspectionForm.created_at">
          {{ $timeZoneDateFormat(inspectionForm.created_at, "LLLL") }}
        </dd>
      </dl>

      <dl class="width_1-2">
        <dt>{{ $t("COMMON.UPDATED_AT") }}</dt>
        <dd v-if="inspectionForm.updated_at">
          {{ $timeZoneDateFormat(inspectionForm.updated_at, "LLLL") }}
        </dd>
      </dl>
    </div>
  </div>
</template>

<script>
import Tags from "@/components/Tags.vue";
import Organization from "@/components/Organization.vue";
import FuelTypes from "@/components/FuelTypes.vue";
import Drivetrains from "@/components/Drivetrains.vue";

export default {
  name: "inspection-form-view-global",

  components: {
    Tags,
    Organization,
    FuelTypes,
    Drivetrains,
  },

  props: ["inspectionForm"],

  data() {
    return {};
  },

  computed: {},

  created() {},

  methods: {
    inspectionFormUpdated() {
      this.$emit("inspectionFormUpdated", true);
    },
  },

  mounted() {},

  watch: {
    inspectionForm(inspectionForm) {},
  },
};
</script>
